import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function getSalutation(now = new Date()) {
    const h = now.getHours();
    if (h < 6)
        return 'Buenas noches';
    if (h < 13)
        return 'Buenos días';
    if (h < 21)
        return 'Buenas tardes';
    return 'Buenas noches';
}
export function HomeGreeting({ name, eyebrow, subtitle }) {
    const now = new Date();
    const dateLabel = now.toLocaleDateString('es-ES', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
    });
    return (_jsxs("header", { className: "mb-8", children: [_jsxs("div", { className: "flex items-center gap-4", children: [_jsxs("span", { className: "font-mono font-bold uppercase", style: {
                            fontSize: '10px',
                            letterSpacing: '0.28em',
                            color: 'var(--accent)',
                        }, children: [eyebrow, " \u2014\u2014"] }), _jsx("span", { className: "flex-1 h-px", style: { background: 'var(--divider)' } }), _jsx("span", { className: "font-mono uppercase", style: { fontSize: '10px', letterSpacing: '0.22em', color: 'var(--fg-3)' }, children: dateLabel })] }), _jsxs("h1", { className: "mt-6 font-black tracking-tight leading-[0.96]", style: {
                    fontSize: 'clamp(1.8rem, 3vw, 2.4rem)',
                    color: 'var(--fg)',
                }, children: [getSalutation(now), ",", ' ', _jsx("span", { className: "italic font-serif font-normal", style: { color: 'var(--accent)' }, children: name })] }), subtitle && (_jsx("p", { className: "mt-3 leading-relaxed max-w-xl", style: { color: 'var(--fg-2)', fontSize: '15px' }, children: subtitle }))] }));
}
//# sourceMappingURL=HomeGreeting.js.map